export const ACTION = {
	REFRESH_DATA: 'REFRESH_DATA',
	CHANGE_MODAL_STATE: 'CHANGE_MODAL_STATE',
	UPDATE_OPTION: 'UPDATE_OPTION',
	UPDATE_TABLE_DATA: 'UPDATE_TABLE_DATA',
	RESET_DATA: 'RESET_DATA',
	UPDATE_BY_ACTION: 'UPDATE_BY_ACTION',
	UPDATE_MODAL_FORM: 'UPDATE_MODAL_FORM',
	LOADING: "LOADING",
	SAVING: "SAVING"
}

export const initialState = {
	openCreateEmail: false,
	emailAddress: '',
	selectedEmailAlert: [],
	dataRefresh: crypto.randomUUID(),
	options: [],
	tableData: [],
	modalTitle: 'Create',
	isLoading: true,
	isSaving: false
};

const emailAlertReducer = (state, action) => {
	const { type, payload } = action;
	let newState = { ...state };

	switch (type) {
		case ACTION.LOADING:
			return {
				...newState,
				isLoading: payload.isLoading
			}
		case ACTION.SAVING:
			return {
				...newState,
				isSaving: payload.isSaving
			}
		case ACTION.REFRESH_DATA:
			return {
				...newState,
				dataRefresh: crypto.randomUUID()
			}
		case ACTION.CHANGE_MODAL_STATE:
			return {
				...newState,
				openCreateEmail: !newState.openCreateEmail
			}
		case ACTION.UPDATE_OPTION:
			return {
				...newState,
				options: payload.options
			}
		case ACTION.UPDATE_TABLE_DATA:
			return {
				...newState,
				tableData: payload.tableData
			}
		case ACTION.RESET_DATA:
			return {
				...newState,
				openCreateEmail: initialState.openCreateEmail,
				modalTitle: initialState.modalTitle,
				selectedEmailAlert: initialState.selectedEmailAlert,
				emailAddress: initialState.emailAddress
			}
		case ACTION.UPDATE_BY_ACTION:
			return {
				...newState,
				selectedEmailAlert: payload.selectedEmailAlert,
				modalTitle: payload.modalTitle,
				emailAddress: payload.emailAddress
			}
		case ACTION.UPDATE_MODAL_FORM:
			return {
				...newState,
				...payload,
			}
		default:
			return newState;
	}
};

export default emailAlertReducer;